<template>
  <el-dialog title="群组信息" class="searchLinkDialog" top="25px" :visible.sync="dialogVisible">
    <div style="height: 400px;overflow: hidden;">
      <div
        class="innerbox"
        style="height: 340px;padding: 0 20px; overflow:auto;overflow-x: hidden;"
      >
      <el-row>
        <el-col :span="24" style="text-align: center;">
            团队名称：&nbsp;{{teamName}}&nbsp;&nbsp;&nbsp;&nbsp;<el-button type="primary" icon="el-icon-edit" circle v-if="groupOwnerIsMe" @click="addClusterMember(1)"></el-button>
        </el-col>
      </el-row>
        <el-row :gutter="24" v-for="m in groupMember" :key="m.ID">
          <el-col :span="14">
            <linkItem :size="true" :mankind="m" style="margin-bottom: 10px;"></linkItem>
          </el-col>
          <el-col :span="10" style="text-align: right;">
            <el-button
              @click="changeChatMan(m)"
              v-if="m.Key != userId"
              type="info"
              icon="el-icon-message"
              circle
            ></el-button>
            <el-button
              @click="removeClusterMember(m)"
              v-if="m.Key != userId && groupOwnerIsMe"
              type="danger"
              icon="el-icon-delete"
              circle
            ></el-button>
          </el-col>
        </el-row>
      </div>
      <div slot="footer" style="text-align: right;margin-top: 20px;" class="dialog-footer">
        <el-button type="danger" @click="close">关 闭</el-button>
        <el-button type="primary" @click="addClusterMember(2)">添加新成员</el-button>
      </div>
    </div>
  <addTeam ref="addTeam" :type="type" :userIdArr="userIdArr" @GetGroupMember="GetGroupMember" @GetGroupName="GetGroupName" :teamInfo="teamInfo"></addTeam>
  <iframe style="display:none;"
            :src="imSrc"></iframe>
  </el-dialog>
</template>

<script>
import mapi from "@/api/modules/basicData/message";
import capi from "@/api/modules/basicData/cluster";
import linkItem from "./linkItem.vue";
import addTeam from "../team/addTeam.vue";
import { mapState, mapMutations } from "vuex";
import { getToken } from "@/util/auth";
const cookieUser = getToken();
export default {
  components: {
    linkItem,
    addTeam
  },
  data() {
    return {
      dialogVisible: false,
      groupMember: [],
      userIdArr:[],
      groupId: "",
      teamName:'',
      teamInfo:{},
      type:0,
      isAdmin:false,
      imSrc:'',
    };
  },
  methods: {
    OpenDialog(row) {
      let val = row.RELATIONID
      this.teamName=row.NODENAME;
      this.teamInfo=row;
      this.dialogVisible = true;
      this.groupId = val;
      this.GetGroupMember(val);
    },
    GetGroupName(val){
      this.teamName=val;
      this.teamInfo.NODENAME=val;
    },
    GetGroupMember(groupId) {
      mapi.GetGroupMember(groupId).then(res => {
        this.groupMember = res;
        this.userIdArr=res.map(function(item) {
          return item.Key;
        })
      });
    },
    close() {
      this.dialogVisible = false;
    },
    addClusterMember(type) {
      this.$refs.addTeam.OpenDialog(this.groupId)
      setTimeout(() => {
					this.type=type;
         this.teamInfo={...this.teamInfo}
				}, 500)
    },
    changeChatMan(info) {
      // this.dialogVisible = false;
      // this.$store.dispatch("message/setChatMan", info);
      console.log('changeChatMan',info);
      if (!info.Key) return;
      if (info.Key === this.userId) {
        this.$message.warning("不能与自己聊天");
        return;
      }
      let url = `RedCoral://IM/?usercode=${cookieUser.account}&users=${info.Key}&chatType=0`;
      window.protocolCheck(url, ()=> {
        this.$message.warning("协议未注册");
      });
      this.imSrc = url;
    },
    removeClusterMember(info) {
      this.$confirm("是否从本团队中移除此人?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          capi.reomoveClusterMember(this.groupId, info.Key).then(res => {
            this.GetGroupMember(this.groupId);
          });
        })
        .catch(err => {
          this.$message({
            type: "info",
            message: "已取消操作"
          });
        });
    },
  },
  computed: {
    ...mapState({
      isCheckbox: state => state.task.isCheckbox,
      userId: state => state.task.userId,
      pathNameArr: state => state.folder.pathNameArr,
      pathName: state => state.folder.pathName,
      OrderIndex: state => state.folder.OrderIndex,
      OrderBy: state => state.folder.OrderBy,
      ViewType: state => state.folder.ViewType,
      folderState: state => state.folder.folderState,
      curTask: state => state.task.curTask,
      Person: state => state.folder.Person
    }),
    groupOwnerIsMe() {
      // 群主是否为自己
      for (let i = 0; i < this.groupMember.length; i++) {
        if (
          this.groupMember[i].Key == this.userId &&
          this.groupMember[i].Name.indexOf("群主") > -1
        ) {
          return true;
        }
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>